<template>
  <v-dialog v-model="showAlerts" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar extended extension-height="30" absolute top style="z-index: 5;">
        <v-btn icon @click="showAlerts = false">
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-toolbar-title>Alarmy</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showAlerts = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-btn
            @click="approveAll"
            color="primary"
            absolute
            bottom
            left
            fab
            style="z-index:5; margin-left: 4px;"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </template>
      </v-toolbar>
      <v-card-text style="height: 100vh; overflow-y: auto; padding-top: 96px" class="pl-0 pb-0">
        <v-timeline dense class="not-timeline" v-if="notifications.length > 0">
          <v-slide-x-reverse-transition
            group
            hide-on-leave
          >
            <v-timeline-item
              v-for="item in notifications"
              :key="item.id"
              :color="colors[item.type]"
              fill-dot
            >
              <v-btn slot="icon" icon class="white--text" @click="approveItem(item.id)">
                <v-icon>{{ icons[item.type] }}</v-icon>
              </v-btn>
              <v-alert
                class="body-2 br-3 mb-0"
              >
                <v-row justify="space-between" align="center">
                  <v-col cols="4" class="py-0"><span v-html="dateShort(item.date)"></span></v-col>
                  <v-col cols="8" class="py-0">
                    {{ $t('alarm' + item.message) }}
                    <v-chip label small>{{ item.displayName }}</v-chip>
                  </v-col>
                </v-row>
              </v-alert>
            </v-timeline-item>
          </v-slide-x-reverse-transition>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!--<v-dialog v-model="showAlerts" scrollable max-width="300px">
    <v-card>
      <v-toolbar flat style="z-index:5;">
        <v-toolbar-title class="not-title">{{ $t('Alarmy') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showAlerts = !showAlerts">
          <v-icon>mdi-close</v-icon>
        </v-btn>
          <v-fab-transition>
            <v-btn
              fab
              color="primary"
              small
              bottom
              left
              absolute
              v-show="showAlerts"
              @click="approveAll"
              style="transition-delay: 0.1s"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-fab-transition>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height: 380px; overflow-y: auto;" class="pa-0">
        <v-timeline dense clipped class="bell">
          <v-slide-x-transition group>
            <v-timeline-item
              small
              fill-dot
              v-for="item in notifications"
              :key="item.id"
              :color="colors[item.type]"
            >
              <v-btn slot="icon" icon small @click="approveItem(item.id)" class="white--text">
                <v-icon>{{ icons[item.type] }}</v-icon>
              </v-btn>
              <div class="pr-3">
                <div class="overline">{{ item.date | dateFormat }}</div>
                <strong>{{ $t('alarm' + item.message) }}</strong>
                <div class="caption">{{ item.displayName }}</div>
              </div>
            </v-timeline-item>
          </v-slide-x-transition>
        </v-timeline>
      </v-card-text>
      <v-divider></v-divider>
        <v-card-text class="caption py-3">{{ notificationsCount }} {{ $t('nz-alarmow') }}</v-card-text>
    </v-card>
  </v-dialog>-->
</template>

<script>
export default {
  computed: {
    showAlerts: {
      get: function () {
        return this.$store.state['notifications'].showAlerts;
      },
      set: function (val) {
        this.$store.state['notifications'].showAlerts = val;
      }
    },
    notifications() {
      return this.$store.getters['notifications/notApproved'].slice();
    },
    notificationsCount() {
      return this.$store.getters['notifications/counter'];
    },
    icons() {
      return this.$store.state['notifications'].icons
    },
    colors() {
      return (this.$vuetify.theme.dark) 
      ? ['#EF5350','#FB8C00','#FB8C00','#42A5F5'] 
      : ['red','orange','orange','blue'];
    },
  },
  methods: {
    approveAll() {
      this.$store.dispatch(`notifications/approveNotifications`, this.notifications);
      setTimeout(() => { this.$store.state['notifications'].showAlerts = false; }, 200);
    },
    approveItem(id) {
      this.$store.dispatch(`notifications/approveNotifications`, [{id: id}]);
    },
    dateShort(value) {
      if (!value) return ''

      var nonthShort = {'01':'sty','02':'lut','03':'mar','04':'kwi','05':'maj','06':'cze','07':'lip','08':'sie','09':'wrz','10':'paź','11':'lis','12':'gru'},
      dat = value.split(' '),
      h = dat[1].slice(0, 5),
      d = dat[0].slice(8, 10),
      m = dat[0].slice(5, 7)
      
      return h + '<br />' + d + ' ' + nonthShort[m];
    },
    
  },
  filters: {
    dateFormat: function (value) {
      if (!value) return ''
      return value.slice(0, 16);
    }
  }
}
</script>